import { ChangeEvent, ComponentPropsWithoutRef, forwardRef, MouseEvent, useImperativeHandle, useRef } from 'react';
import cn from 'classnames';

import Count from './Count';
import Delete from './Delete';
import Search from './Search';

export enum UtilType {
  Count = 'count',
  Search = 'search',
  Delete = 'delete'
}

type Props = {
  value: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  labelTitle: string;
  utilType?: UtilType;
  onUtilClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  maxLength?: number;
  id: string;
} & ComponentPropsWithoutRef<'input'>;

const Input = forwardRef<HTMLInputElement, Props>(
  ({ value, className, utilType, onUtilClick, labelTitle, maxLength, id, ...props }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const renderUtil = () => {
      switch (utilType) {
        case UtilType.Count:
          return <Count currentLength={value.length || 0} maxLength={maxLength || 0} />;
        case UtilType.Search:
          return <Search onClick={onUtilClick} />;
        case UtilType.Delete:
          return <Delete inputRef={inputRef} onMouseDown={onUtilClick} />;
        default:
          return null;
      }
    };

    useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

    return (
      <>
        <label htmlFor={id} className="screen_out">
          {labelTitle}
        </label>
        <input
          ref={inputRef}
          id={id}
          className={cn('tf_comm', className)}
          value={value}
          maxLength={maxLength}
          {...props}
        />
        <div className="util_g">{renderUtil()}</div>
      </>
    );
  }
);

Input.displayName = 'Input';

export default Input;
